import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { IpexFileService } from '../../services/ipex-file.service';

@Component({
    selector: 'app-pcx-avatar-by-fle-id',
    templateUrl: './pcx-avatar-by-fle-id.component.html',
    styleUrls: ['./pcx-avatar-by-fle-id.component.scss'],
    standalone: false
})
export class PcxAvatarByFleIdComponent implements OnChanges, OnDestroy {
    @Input() FileId: string;
    @Input() round = true;
    @Input() size = 24;
    @Input() bgColor = '#DADADA';
    @Input() fgColor = '#FFFFFF'; // $dark-80
    @Input() addBorderColorForImage = true;
    @Input() borderColor = ''; // $primary-500
    @Input() showEmail = false;
    @Input() DisplayName = 'N/A';
    url: string = null;
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private readonly ipexFileService: IpexFileService) {}

    //TODO: This should not be efficient for use in list for repetitive call

    ngOnChanges(changes: any): void {
        if (changes.FileId && changes.FileId.currentValue) {
            this.url = '';
            this.getFileUrl(changes.FileId.currentValue);
        }
    }

    private getFileUrl(fileId: string): void {
        this.ipexFileService
            .getFileUrlById(fileId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: url => (this.url = url),
                error: err => {
                    console.error('Error getting file url', err);
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
